module.exports = __webpack_public_path__ + "img/icon-excel@3x.0a150b6d.png";